var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24ShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-shopping_cart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M16,20a2,2,0,1,1,2-2A2,2,0,0,1,16,20ZM6,20a2,2,0,1,1,2-2A2,2,0,0,1,6,20Zm11.5-5H4.982a.764.764,0,0,1-.653-.37l-.22-.381a.769.769,0,0,1,0-.71L5.97,9.84a2.109,2.109,0,0,1-.27-.35L1.42,2H.5A.5.5,0,0,1,0,1.5V.5A.5.5,0,0,1,.5,0h.927A2,2,0,0,1,3.16,1l.56,1H19.5a.5.5,0,0,1,.5.5V3a4.783,4.783,0,0,1-.65,2.361L17,9.49A2.949,2.949,0,0,1,14.49,11H8.26a2.719,2.719,0,0,1-.64-.09L6.62,13H17.5a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,17.5,15ZM4.87,4h0L7.44,8.5A1,1,0,0,0,8.3,9h6.23a1.006,1.006,0,0,0,.751-.5L17.64,4.37a2.276,2.276,0,0,0,.1-.234c.017-.046.034-.092.053-.137H4.87Z",
    transform: "translate(2 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24ShoppingCart);
export default __webpack_public_path__ + "static/media/icon-24-shopping_cart.d6f54c1335d2fa0e7709b41e064f95ec.svg";
export { ForwardRef as ReactComponent };